import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/** API path prefixes authenticated by Firebase only; never sent the Functions key. */
const FIREBASE_ONLY_PATHS = ['/api/v1/remediation-projects', '/api/v1/compliance/evidence-requests'];

@Injectable()
export class FunctionsKeyInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const apiBaseUrl = environment.app_api_url;
    const functionsKey = (environment as any).app_api_token as string | undefined;

    const normalizedKey = (functionsKey ?? '').trim();
    const isPlaceholderKey =
      normalizedKey === '' ||
      /placeholder/i.test(normalizedKey) ||
      normalizedKey === 'DEVELOPMENT_API_TOKEN_PLACEHOLDER';

    if (!apiBaseUrl || isPlaceholderKey) {
      return next.handle(req);
    }

    // Only attach the Functions key when calling the Azure Functions API.
    if (!req.url.startsWith(apiBaseUrl)) {
      return next.handle(req);
    }

    // The runtime configuration endpoint is intentionally anonymous bootstrap
    // infrastructure. Adding a Functions key forces extra browser preflights
    // and can make startup diagnostics look slower than the endpoint actually is.
    if (req.url === `${apiBaseUrl}/api/configuration`) {
      return next.handle(req);
    }

    // Endpoints that authenticate with the Firebase ID token alone (Azure
    // authLevel "anonymous" + withAuth) must not receive the shared key (#817).
    if (FIREBASE_ONLY_PATHS.some((path) => req.url.startsWith(`${apiBaseUrl}${path}`))) {
      return next.handle(req);
    }

    // Allow callers to override explicitly.
    if (req.headers.has('x-functions-key')) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: {
          'x-functions-key': normalizedKey,
        },
      })
    );
  }
}
